import { Pipe, PipeTransform } from '@angular/core';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import { UnderlyingAssetArrayFE } from 'src/app/product-capture/model/interfaces/underlying-asset-array-fe.interface';
import { ProductUtils } from 'src/app/product-capture/utils/product.utils';

@Pipe({
  name: 'filterPerformanceType',
})
export class FilterPerformanceTypePipe implements PipeTransform {
  transform(
    performanceTypeItems: { id: string; displayValue: string }[],
    underlyingAssets: UnderlyingAssetArrayFE[],
    productType?: string
  ): { id: string; displayValue: string }[] {
    if (productType === ProductTypeEnum.CHOOSER) {
      return performanceTypeItems.filter(
        (item) =>
          item.id === PERFORMANCE_TYPE_KEYS.BEST_OF ||
          item.id === PERFORMANCE_TYPE_KEYS.WORST_OF
      );
    }

    if (!ProductUtils.allowMultipleAssets(productType as ProductTypeEnum)) {
      return performanceTypeItems.filter(
        (item) => item.id === PERFORMANCE_TYPE_KEYS.SINGLE
      );
    }

    if (!underlyingAssets || underlyingAssets.length <= 1) {
      return performanceTypeItems;
    }

    return performanceTypeItems.filter(
      (item) => item.id !== PERFORMANCE_TYPE_KEYS.SINGLE
    );
  }
}
